import styled from 'styled-components';
import { BreadcrumbsContainer } from '4ff-lib-foundation/lib/AppFrame/publicAPI/components';

// MDS Breadcrumbs
export const MDSBreadcrumbsLayout = styled.div`
  background-color: #fff;
  border-bottom: 1px solid #e0e0e2;
  display: flex;
  flex-shrink: 0;
  height: 50px;
  padding: 0 16px;
`;

export const MDSBreadcrumbsContainer = styled(BreadcrumbsContainer)`
  position: relative !important;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
`;
